const nftTypes = ['mecha', 'threeDice'] as const;
export type NFTType = typeof nftTypes[number];
export const isNFTType = (value: string): boolean =>
  nftTypes.includes(value as NFTType);
